import React from 'react';

const InsightsTab: React.FC = () => {
  return (
    <div className="h-full flex items-center justify-center">
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          Insights Dashboard
        </h2>
        <p className="text-gray-600">
          Analysis functionality coming soon...
        </p>
      </div>
    </div>
  );
};

export default InsightsTab;